<template>
  <modal
    title="KPA Summary"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div v-if="selectedFunction" class="function-details">
      <div class="container-fluid">
        <div class="row">
          <div class="pl-0 col">
            <p class="font-semibold">{{ selectedFunction.name }}</p>
            <p class="font-medium my-2">KPA summary listed for selected function.</p>
            <p class="text-grey">LAST EDITED: {{ formatDate(selectedFunction.updatedAt) }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedFunction" class="kpa-summary">
      <p class="font-semibold">KPA Descriptions.</p>
      <ol>
        <li v-for="kpi in selectedFunction.kpis" :key="kpi.id">
          {{ kpi.name }}
        </li>
      </ol>
    </div>
    <div class="button-wrapper mt-5">
      <!-- <button class="button button-primary button-long" @click="editFunction">
        Edit Function
      </button> -->
      <p
        class="cursor-pointer pt-2 pr-3 mb-0"
        @click="closeModal"
      >
        Close
      </p>
    </div>
  </modal>
</template>

<script>
export default {
  //   data() {
  //     return {
  //       showModal: false,
  //     };
  //   },
  props: ["selectedFunction", "showModal"],
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    formatDate(d){
      return new Date(d).toDateString()
    },
    editFunction() {
      localStorage.setItem(
        "functionToEdit",
        JSON.stringify(this.selectedFunction)
      );
      this.$router.push({ name: "EditFunction" });
    },
  },
};
</script>

<style scoped>
.row {
  padding-top: 1rem !important;
}
.kpa-summary {
  margin-top: 1rem;
}
.text-grey{
  color: #7A90A7;

}
li {
  list-style-type: initial !important;
  margin-left: 1rem;
  padding-top: 0.5rem;
}
</style>
